var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonnelsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C6.51878 8 7.75 6.76878 7.75 5.25C7.75 3.73122 6.51878 2.5 5 2.5C3.48122 2.5 2.25 3.73122 2.25 5.25C2.25 6.76878 3.48122 8 5 8Z",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.5C0.5 12.3065 0.974106 11.1619 1.81802 10.318C2.66193 9.47411 3.80653 9 5 9C6.19347 9 7.33807 9.47411 8.18198 10.318C9.02589 11.1619 9.5 12.3065 9.5 13.5",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5007 2.94403C9.91595 2.67422 10.3963 2.52154 10.8912 2.50212C11.386 2.48269 11.8769 2.59724 12.312 2.83366C12.7471 3.07008 13.1103 3.41961 13.3632 3.84534C13.6162 4.27106 13.7495 4.75719 13.749 5.25239C13.7486 5.74759 13.6145 6.23348 13.3608 6.65877C13.1071 7.08405 12.7433 7.43295 12.3078 7.66862C11.8722 7.90428 11.3812 8.01798 10.8864 7.99769C10.3916 7.97741 9.91148 7.82389 9.4967 7.55337",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.11134C10.659 8.96203 11.3432 8.9629 12.0019 9.11389C12.6605 9.26488 13.2768 9.56211 13.805 9.98358C14.3331 10.405 14.7597 10.9399 15.0532 11.5486C15.3466 12.1573 15.4993 12.8243 15.5 13.5",
    stroke: "white",
    strokeWidth: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelsWhite);
export default __webpack_public_path__ + "static/media/personnels-white.56e23de0caebf7f61ee683dc98df9f04.svg";
export { ForwardRef as ReactComponent };